import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import styles from "../pages/blog/bloggen.module.css";

export default function AuthorDropDown({ onSelectAuthor }) {
  const [authorOptions, setAuthorOptions] = useState([]);

  const API_URL =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000/"
      : "https://api.hillerodfrimenighed.dk/";

  useEffect(() => {
    async function getAuthors() {
      try {
        const response = await axios.get(`${API_URL}blog/author/`);
        setAuthorOptions(response.data);
      } catch (error) {
        console.error("Error fetching authors:", error);
        setAuthorOptions([]);
      }
    }
    getAuthors();
  }, []);



  return (
    <Select
      isClearable
      options={authorOptions}
      className={styles.authorDropDown}
      placeholder="Vælg forfatter"
      onChange={(selected) => onSelectAuthor(selected ? selected.value : 0)}
    />
  );
}
